import React from 'react';

const ControlLabel = (props) => <label {...props} className={props.className + (props.row ? ' col-form-label col text-right' : '')}>
  {props.children}
</label>;

export default ControlLabel;